/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=831e7186&scoped=true&lang=html&"
import script from "./OrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=831e7186&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831e7186",
  null
  
)

export default component.exports